"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
var _typeof2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _couponCode = _interopRequireDefault(require("@/api/activity/couponCode.js"));
var _upgradeStrategy = require("@/api/basic/upgradeStrategy");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'couponEAct',
  components: {},
  props: {
    refresh: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    refresh: {
      immediate: true,
      handler: function handler(newId, oldId) {
        // 避免初始化时的不必要调用
        if (newId === oldId && oldId !== undefined) return;
        console.log('actId', newId);
        if (newId) {
          this.fetchList();
        }
      }
    }
  },
  emits: ['addAct', 'handleEdit', 'detailUser'],
  data: function data() {
    return {
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      times: [],
      searchForm: {
        startTime: '',
        endTime: '',
        keywords: '',
        page: 1,
        limit: 10,
        total: 0
      },
      tableData: [],
      // ...新增二维码相关状态...
      qrDialogVisible: false,
      qrImage: '',
      qrObj: {}
    };
  },
  computed: {
    maxHeight: function maxHeight() {
      return "".concat(window.innerHeight - 497, "px");
    }
  },
  methods: {
    showCode: function showCode(row) {
      console.log('row', row);
      var url = 'http://api.gagacafe.com/exchange/' + row.id;
      console.log('url', url);

      // 使用第三方二维码生成服务（qrserver）
      var size = 500;
      var qrApi = "https://api.qrserver.com/v1/create-qr-code/?size=".concat(size, "x").concat(size, "&data=").concat(encodeURIComponent(url));

      // 直接将生成链接赋值给图片 src，弹窗显示
      this.qrImage = qrApi;
      this.qrObj = row;
      this.qrDialogVisible = true;
    },
    changeStatus: function changeStatus(id, status) {
      var _this = this;
      console.log('改变状态', id, status);
      _couponCode.default.changeActStatus({
        id: id,
        status: status
      }).then(function (res) {
        _this.$message.success('状态修改成功');
        _this.fetchList();
      }).catch(function (err) {
        _this.$message.error('状态修改失败');
      });
    },
    addAct: function addAct() {
      this.$emit('addAct');
    },
    handleCoupon: function handleCoupon(row) {
      console.log('优惠券', row);
      this.$emit('handleCoupon', row);
    },
    handleEdit: function handleEdit(row) {
      this.$emit('handleEdit', row);
    },
    handleCopy: function handleCopy(row) {
      this.$emit('handleCopy', row);
    },
    detailUser: function detailUser(row) {
      this.$emit('detailUser', row);
    },
    changeTime: function changeTime(e) {
      console.log(e);
      if (!e || e.length === 0) {
        // 清除筛选条件
        this.searchForm.startTime = '';
        this.searchForm.endTime = '';
        this.fetchList(); // 重新加载数据
      } else {
        this.searchForm.startTime = e[0];
        this.searchForm.endTime = e[1];
        console.log((0, _typeof2.default)(e[0]), e[0]);
      }
    },
    indexMethod: function indexMethod(index) {
      return (this.searchForm.page - 1) * this.searchForm.limit + index + 1;
    },
    handleSortChange: function handleSortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      this.searchForm.sortField = prop;
      this.searchForm.sortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : '';
      this.fetchList();
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      _couponCode.default.getActList(this.searchForm).then(function (res) {
        res.records.forEach(function (item) {
          var date = new Date(item.begDate);
          var date2 = new Date(item.endDate);
          var year = date.getFullYear();
          var month = _this2.pad(date.getMonth() + 1);
          var day = _this2.pad(date.getDate());
          var hours = _this2.pad(date.getHours());
          var mins = _this2.pad(date.getMinutes());
          var secs = _this2.pad(date.getSeconds());
          item.begDate = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
          var year2 = date2.getFullYear();
          var month2 = _this2.pad(date2.getMonth() + 1);
          var day2 = _this2.pad(date2.getDate());
          var hours2 = _this2.pad(date2.getHours());
          var mins2 = _this2.pad(date2.getMinutes());
          var secs2 = _this2.pad(date2.getSeconds());
          item.endDate = "".concat(year2, "-").concat(month2, "-").concat(day2, " ").concat(hours2, ":").concat(mins2, ":").concat(secs2);
        });
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    handleDel: function handleDel(row) {
      this.$confirm("\u786E\u5B9A\u8981\u79FB\u9664 ".concat(row.activityName, " \u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // couponApi.deleteAct({ id: row.id }).then(res => {
        // this.$message.success('活动移除成功')
        //     this.fetchList()
        // }).catch(err => {
        //     this.$message.error('活动移除失败')
        // })
      }).catch(function () {
        // 取消操作
      });
    },
    download: function download() {},
    // 每页条数变化
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    }
  },
  mounted: function mounted() {
    this.fetchList();
  }
};